import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import { useFeatureSwitchList } from '@src/data/api/credit-api/credit-api'
import { type JSX } from 'react'

interface Props {
  children: JSX.Element
}

// #62287 — gate auth flow on feature flags load: while fetching, render the existing
// loading fallback. Once fetch resolves (success or single-try failure with retry:false),
// unblock. On failure, downstream useFeatureFlags() returns {} → kill-switch active → standard login.
const FeatureFlagsGate = ({ children }: Props): JSX.Element => {
  const [featureSwitchInfo, isFetching] = useFeatureSwitchList()
  if (isFetching && !featureSwitchInfo) return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress aria-label="Loading…" />
    </Box>
  );
  return children
}

export default FeatureFlagsGate
